module.exports = __webpack_public_path__ + "static/media/as.caaf405e.svg";